import { alpha } from '@mui/material/styles';

/**
 *  Light Theme is the default theme used in material-ui. It is guaranteed to
 *  have all theme variables needed for every component. Variables not defined
 *  in a custom theme will default to these values.
 */
const theme = {
  fontFamily: 'Roboto, sans-serif',
  typography: {
    fontSize: 16,
  },
  palette: {
    primary: {
      main: '#0054ff',
    },
    secondary: {
      main: '#008f81',
    },
    text: {
      primary: '#000',
      secondary: alpha('#000', 0.54),
      disabled: '#000',
    },
  },
};
export default theme;
